import { Request } from "@tools/base";;
const { Axios } = Request;

const URL = "/v1/app/";

//获取市场提示列表
export function get_marketTips(config?) {
  return Axios.get(URL + `public/market-tips-config`, config);
}

//获取维护提示语
export function get_maintainTips(config?) {
  return Axios.get(URL + `public/maintain-tips-config`, config);
}

//获取热门搜索
export function get_searchMarketHot(config?) {
  return Axios.get(URL + `public/search-market/hot`, config);
}
